import React from 'react'
import { Card } from 'primereact/card'
import './CustomCardDistance.css'
import { isRouteAllowed } from '../../services/permission/menus'

export default function CustomCardDistance({ title, subTitle, value, barColor, btn, selectedTp }) {
  const allowed = isRouteAllowed(42)
  return (
    <Card
      className="CustomCardColorBar"
      title={title}
      subTitle={subTitle}
      style={{ borderTop: `5px solid ${barColor}` }}
    >
      {allowed ? (
        <>
          <h1 className="text-center" style={{ margin: 0 }}>
            {value}
          </h1>
          <div style={{ textAlign: 'center', marginTop: 10 }}>{btn}</div>
        </>
      ) : (
        <h2 className="text-center">Sem permissão</h2>
      )}
    </Card>
  )
}
